import { render, staticRenderFns } from "./action.vue?vue&type=template&id=788f3b22&scoped=true"
import script from "./action.vue?vue&type=script&lang=js"
export * from "./action.vue?vue&type=script&lang=js"
import style0 from "./action.vue?vue&type=style&index=0&id=788f3b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f3b22",
  null
  
)

export default component.exports